import { render, staticRenderFns } from "./detailfule.vue?vue&type=template&id=1f5f6f27"
import script from "./detailfule.vue?vue&type=script&lang=js"
export * from "./detailfule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports